import { render, staticRenderFns } from "./CartTableItemRowBase.vue?vue&type=template&id=57220f03&"
import script from "./CartTableItemRowBase.vue?vue&type=script&lang=js&"
export * from "./CartTableItemRowBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports